import { useAuth } from '../context/AuthContext';
import Badge from '../components/ui/Badge';

export default function MyPlanPage() {
  const { user, company } = useAuth();

  const status = user?.subscriptionStatus || 'free';
  const plan = user?.plan || status;

  return (
    <div className="page narrow">
      <header className="page-header">
        <div>
          <h1>Mi plan</h1>
          <p className="muted">Solo lectura · la compra continúa en Google Play / App Store</p>
        </div>
      </header>

      <section className="panel">
        <ul className="simple-list">
          <li>
            <span className="muted">Plan actual</span>
            <Badge tone="info">{plan}</Badge>
          </li>
          <li>
            <span className="muted">Estado</span>
            <strong>{status}</strong>
          </li>
          <li>
            <span className="muted">Trial</span>
            <span>{user?.trialEndDate || user?.trialStartDate || '—'}</span>
          </li>
          <li>
            <span className="muted">Vencimiento</span>
            <span>{user?.expiryDate || '—'}</span>
          </li>
          <li>
            <span className="muted">Empresa</span>
            <span>{company?.razonSocial || '—'}</span>
          </li>
        </ul>
      </section>

      <p className="muted">
        El admin no modifica la lógica de facturación de tiendas. El bypass E2E de pagos
        solo aplica en builds de prueba; no es una solución permanente.
      </p>
    </div>
  );
}
